import { useStaticQuery, graphql } from 'gatsby'

export const useTrustPilot = () => {
  const { trustPilotSummary } = useStaticQuery(
    graphql`
      query trustPilot {
        trustPilotSummary(domain: { eq: "stoxenergy.com" }) {
          score {
            stars
          }
          total
        }
      }
    `,
  )
  return trustPilotSummary
}
